import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledTableResponsive } from './TableResponsive.styles';

/**
 * Provides a table with responsive behavior. On small screens, users can
 * scroll or swipe sideways to see all of the table's content.
 *
 * @since 8.0.0
 */
export var TableResponsive = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledTableResponsive, _extends({
    ref: forwardedRef
  }, props));
});
TableResponsive.displayName = 'Table.Responsive';